module.exports = __webpack_public_path__ + "static/media/arrow-icon.861901eb.svg";